module.exports = __webpack_public_path__ + "static/media/Mapa-Mato Grosso.3ba8831e.svg";